module.exports = __webpack_public_path__ + "static/img_4651-9cf990b4195752b0db76c440a3d49345.webp";